import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';

const kStepMs = 300;

/** The customer is about to say something. */
export const TypingDots = memo(({ color }: { color: string }) => {
  const { rpx } = useResponsiveContext();
  const dots = useRef([0, 1, 2].map(() => new Animated.Value(0.3))).current;
  useEffect(() => {
    const loop = Animated.loop(
      Animated.stagger(
        kStepMs,
        dots.map(dot =>
          Animated.sequence([
            Animated.timing(dot, {
              toValue: 1,
              duration: kStepMs,
              useNativeDriver: true,
            }),
            Animated.timing(dot, {
              toValue: 0.3,
              duration: kStepMs,
              useNativeDriver: true,
            }),
          ]),
        ),
      ),
    );
    loop.start();
    return () => loop.stop();
  }, [dots]);
  return (
    <View
      accessibilityLabel="正在输入"
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: rpx(4),
        height: rpx(21),
      }}
    >
      {dots.map((dot, i) => (
        <Animated.View
          key={i}
          style={{
            width: rpx(6),
            height: rpx(6),
            borderRadius: rpx(3),
            backgroundColor: color,
            opacity: dot,
          }}
        />
      ))}
    </View>
  );
});
